import React from "react";
import CountDown from "./CountDown";

const CountDownOverlay = (props) => {
    const background = props.background;
    const styles = {
        background: background
    }
    return (
        <div style={styles} className="countdown-overlay">
            <h1 className="countdown-timer"><CountDown countTime={3} /></h1>
        </div>
    );
};

export default CountDownOverlay;